import axios from 'axios';

const switchAccounts = id => {
  return axios.put(`clients/swap/${id}`);
};

export { switchAccounts };
